import { ECompletionYearType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectCompletionYearFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const CompletionYearContainer: FC = () => {
  const { label, value, options, yearOffset, availableCompletionYearTypes } = useSelector(selectCompletionYearFilter);

  const onChange = useFilterChangeCallback();

  const handleCompletionYearChange = useCallback(
    (newValue: NonEmptyArray<ECompletionYearType> | null) => {
      onChange({
        action: 'setCompletionYearTypes',
        arguments: [
          {
            completionYearTypes: newValue,
            yearOffset,
            availableYearTypes: availableCompletionYearTypes,
          },
        ],
      });
    },
    [availableCompletionYearTypes, onChange, yearOffset],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleCompletionYearChange} />
    </AdvancedFilterRow>
  );
};
